import { sendGet, sendPost } from "./axiosClients";

export const getUserNotification = (data) => sendGet('/user/notification', data);
export const readUserNotification = (data) => sendPost('/user/notification/mark-as-read', data);
export const readAllUserNotification = (data) => sendPost('user/notification/mark-all-as-read', data);